import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  [getActionTypes(actionPrefix).SET_STATUS]: () => ({
    popupStatus: action.payload.popupStatus,
  }),
  [getActionTypes(actionPrefix).SET_SELECTED_OPTIONS]: (state) => ({
    selectedOptions: {
      ...state.selectedOptions,
      [action.payload.selectBoxName]: action.payload.selectedOptions,
    },
  }),
  [getActionTypes(actionPrefix).SET_SDK]: () => ({
    sdk: action.payload.sdk,
  }),
  [getActionTypes(actionPrefix).SET_IS_LOADING]: () => ({
    isLoading: action.payload.isLoading,
  }),
});
